export default {
  title: {
    id: 'insurance_cart_title',
    defaultMessage:
      'Make your {deviceName, html} (almost) immortal with our coverage.',
  },
  backupPlusTitle: {
    id: 'insurance_cart_title_backup_plus',
    defaultMessage:
      'Protect your {deviceName, html} with a plan exclusively for refurbished devices.',
  },
}
